import "./Modal.scss";
import React, { useEffect } from "react";
import CustomModal from "./CustomModal";
import { Button } from "../form";
import useButtonLoader from "hooks/useButtonLoader";
import { getFromLocal, removeToken } from "config/axiosInstance";
import { userLogoutApi } from "services/userProfile";
import useNavigation from "hooks/useNavigation";
import { toastMessage } from "utils/toastMessageHelper";
import { MdOutlineCancel } from "react-icons/md";
import { useTranslation } from "react-i18next";

const LogoutModal = ({ show, closeLogoutModal }) => {
  // Hook
  const { t, i18n } = useTranslation();
  const [logoutButtonLoader, setLogoutButtonLoader] = useButtonLoader(
    t("COMMON.yes")
  );
  const { navigateTo } = useNavigation();

  // logout handler
  const userLogoutHandler = async (e) => {
    setLogoutButtonLoader(true);
    try {
      const reqData = { token: getFromLocal("token") };
      const responseData = await userLogoutApi(reqData);
      const { message = "", status } = responseData;
      if (status === 200) {
        toastMessage(message, "success", "userLogout");
        closeLogoutModal();
        removeToken();
        removeToken("i18nLng");
        i18n.changeLanguage("en");
        navigateTo("/");
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setLogoutButtonLoader(false);
    }
  };

  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n.language]);

  return (
    <>
      <CustomModal
        show={show}
        handleClose={closeLogoutModal}
        className={"logoutModal"}
        closeButton={false}
      >
        <div className="wrap_log_modal">
          <div className="icons">
            <MdOutlineCancel />
          </div>
          <h3>{t("LOGOUT.logoutSure")}</h3>
          <p>{t("LOGOUT.againLoginAfterLogout")}</p>
          <div className="button_wrap button_center">
            <Button
              className={"light"}
              ref={logoutButtonLoader}
              onClick={userLogoutHandler}
            >
              {t("COMMON.yes")}
            </Button>
            <Button onClick={closeLogoutModal}>{t("COMMON.no")}</Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default LogoutModal;
